module.exports = __webpack_public_path__ + "static/media/vopa_logo.83f57744.png";